import React, { useState } from "react";

export const useSlides = (props) => {

  // 左侧slideList栏的渲染数组
  const [slides, setSlides] = useState([]);

  return { slides, setSlides };
}